import React, { Fragment, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import { Row, Col, Card } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import useFullPageLoader from "../../../hooks/useFullPageLoader";
import Toastr from "../../components/common/Toastr";
import {
  restApi,
  restApi_PD,
} from "../../../services/wooCommerceRestApi/restApi";
import { productActions } from "../../../_store";
import CommonService from "../../../services/Common/CommonService";
import { el } from "date-fns/locale";

const AttributesTab = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loader, showLoader, hideLoader] = useFullPageLoader();

  // #region Reducers ------------------  Reducers --------------------------------

  const { master, product, auth } = useSelector((state) => state);
  const { attributeDrpList, categoryDrpList, subCategoryDrpList, shippingMethodDrpList, termDrpList } = master;
  const { productTabList, productResponse, previousProductTabList } = product;
  
  const currentUser = auth.user;
  const attributeTabData=productTabList;


  // #end region Reducers ------------------  Reducers End --------------------------------

  //preview page
  const prevTab = () => {
    dispatch(productActions.tempActiveProductTab("Inventory"));
  };


  // #region handle Dropdown Change function
  const handleDrpChange = (event, title) => {
    let newFormData = { ...attributeTabData };
    newFormData[title] = event.value && parseInt(event.value);
    if (title === "AttributeID") {
      newFormData.AttributeOption = {
        value: parseInt(event.value),
        label: event.label,
      };
    }
    dispatch(productActions.tempSetProductTabData(newFormData));
  };

  const handleTermDrpChange = (
    event,
    index,
    AttributeID,
    ProductAttributeID
  ) => {
    const oldAttributeTabData = { ...attributeTabData };
    let oldProductAttributeModelList = [
      ...oldAttributeTabData.ProductAttributeModelList,
    ];

    const rowData = { ...oldProductAttributeModelList[index] };
    if (event) {
      rowData.ProductTermOptionList = [...event];
    } else {
      rowData.ProductTermOptionList = [];
    }

    oldProductAttributeModelList[index] = { ...rowData };
    oldAttributeTabData.ProductAttributeModelList =
      oldProductAttributeModelList;

    dispatch(productActions.tempSetProductTabData(oldAttributeTabData));
  };

  // #end region handle Dropdown Change function

  const handleAddAttribute = () => {
    
    const oldAttributeTabData = { ...attributeTabData };
    const oldProductAttributeModelList = [
      ...oldAttributeTabData.ProductAttributeModelList,
    ];

    const drpAttributeID = oldAttributeTabData.AttributeID;
    if (drpAttributeID && drpAttributeID > 0) {
      const isExitAttribute = !!oldProductAttributeModelList.find(
        (d) => d.AttributeID === drpAttributeID && d.IsDeleted === false
      );

      if (!isExitAttribute) {
        let attrOption = attributeDrpList.filter(
          (d) => d.value === oldAttributeTabData?.AttributeID
        );
        let wcIdAttributeID = attrOption && attrOption[0]?.wcid;
        let PDwcIdAttributeID = attrOption && attrOption[0]?.pdWcid;

        const newAttribute = {
          ProductAttributeID: 0,
          AttributeID: oldAttributeTabData && oldAttributeTabData.AttributeID,
          AttributeName:
            oldAttributeTabData && oldAttributeTabData.AttributeOption.label,
          ProductID: 0,
          IndexID: 0,
          Status: 1,
          WCAttributeID: wcIdAttributeID,
          PDWCAttributeID: PDwcIdAttributeID,
          IsDeleted: false,
          ProductTermOptionList: [],
        };

        oldProductAttributeModelList.push(newAttribute);
        oldAttributeTabData.ProductAttributeModelList =
          oldProductAttributeModelList;
        dispatch(productActions.tempSetProductTabData(oldAttributeTabData));
      } else {
        Toastr("Attribute already exists", "warning");
      }
    } else {
      Toastr("Please select attribute ", "warning");
    }
  };

  const handleRemoveAttribute = (index, AttributeID, ProductAttributeID) => {
    const oldAttributeTabData = { ...attributeTabData };
    const oldProductAttributeModelList = [
      ...oldAttributeTabData.ProductAttributeModelList,
    ];
    if (ProductAttributeID > 0) {
      const rowData = { ...oldProductAttributeModelList[index] };
      rowData.IsDeleted = true;
      oldProductAttributeModelList[index] = { ...rowData };
    } else {
      oldProductAttributeModelList.splice(index, 1);
    }

    oldAttributeTabData.ProductAttributeModelList =
      oldProductAttributeModelList;
    dispatch(productActions.tempSetProductTabData(oldAttributeTabData));
  };

  // All Tab Add Product handleInsertProduct function
  const handleInsertProduct = () => {
    const productData = { ...attributeTabData };
    productData.CreatedBy = currentUser.Id;

    var iserror = false;
    var error = false;
    var start2 = performance.now();
    let isErrorThreshold = false;
    const IsLocationExist = productData.TypeLocationList.some((item, index) => item.Aisle === "" || item.Aisle === "0" || (item?.Aisle?.length !== 2) || item.Bay === "" || item.Bay === "0" || (item?.Bay?.length !== 2) || item.Level=== "");


    if (
      !productData.ProductName ||
      !productData.WarehouseOption ||
      !productData.CategoryOption ||
      !productData.SubCategoryOption ||
      // !productData.Aisle ||
      // productData.Aisle.length !== 2 ||
      // !productData.Level ||
      // productData.Level.length === 1 ||
      // !productData.Bay ||
      // productData.Bay.length !== 2 ||
      !productData.Description ||
      !productData.PackageTypeOption ||
      !productData.Cost ||
      productData.Cost === "$0.00" ||
      productData.PerBoxCount <= 0 ||
      !productData.WarrantyPeriod  ||
      productData.WarrantyPeriod === 0 ||
      !productData.RegularPrice ||
      productData.RegularPrice === "$0.00" ||
      !productData.GPARTNERPrice ||
      productData.GPARTNERPrice === "$0.00" ||
      !productData.GStarPrice ||
      productData.GStarPrice === "$0.00" ||
      !productData.PFAPrice ||
      productData.PFAPrice === "$0.00" ||
      !productData.GVendorPrice ||
      productData.GVendorPrice === "$0.00" ||
      !productData.GAssociatePrice ||
      productData.GAssociatePrice === "$0.00" ||
      !productData.Weight ||
      !parseFloat(productData.Weight && productData.Weight) > 0 ||
      !productData.DimensionLength ||
      !parseFloat(productData.DimensionLength && productData.DimensionLength) >
        0 ||
      !productData.DimensionWidth ||
      !parseFloat(productData.DimensionWidth && productData.DimensionWidth) >
        0 ||
      !productData.DimensionHeight ||
      !parseFloat(productData.DimensionHeight && productData.DimensionHeight) >
        0 ||
      !productData.ShippingMethodOption ||
      !productData.PartyDecoPrice ||
      productData.PartyDecoPrice === "$0.00" ||
      // InventoryTab
      !productData.SKU ||
      !productData.VendorOption ||
      !productData.Manufacturer ||
      (productData.IsGemar === false && productData.IsPartyDeco === false) ||
      IsLocationExist===true || productData?.TypeLocationList?.length===0
    ) {
      error = true;
    }

    if (
      // !productData.StockQuantity ||
      // parseInt(productData.StockQuantity) === 0 ||
      !productData.AllowbackordersOption ||
      !productData.LowStockThreshold ||
      parseInt(productData.LowStockThreshold) === 0 ||
      !productData.HighStockThreshold ||
      parseInt(productData.HighStockThreshold) === 0
    ) {
      error = true;
    }

    if (!productData.QuotaTrigger1 || !productData.QuotaTrigger2) {
      error = true;
    }

    let isLocationDuplicate =false;
      if(productData?.TypeLocationList?.length > 1)
      {
        for (let item of productData.TypeLocationList) {
        
         let location= item.Aisle +item.Bay+ item.Level;
         let filterLocation= productData.TypeLocationList.filter(item=>(item.Aisle +item.Bay+ item.Level) === location && item.IsDeleted===false);

        if(filterLocation?.length>1)
        {
          isLocationDuplicate=true;
         // Toastr("please check previous data location is already used", "warning");
          break;
        }
       }
      }

    if (
      parseInt(productData.QuotaTrigger1) <
        parseInt(productData.QuotaTrigger2) ||
      parseInt(productData.QuotaTrigger1) ===
        parseInt(productData.QuotaTrigger2)
    ) {
      isErrorThreshold = true;
    }



    if (!error && !isErrorThreshold && !isLocationDuplicate) {
      let C_WCParentId = 0;
      let C_pdWCParentId = 0;
      let categoryDrp = categoryDrpList.filter(
        (d) => d.value === productData.CategoryID
      );
      if (categoryDrp && categoryDrp[0]) {
        C_WCParentId = categoryDrp[0]?.wcid;
        C_pdWCParentId = categoryDrp[0]?.pdWcid;
        productData.CategoryName = categoryDrp[0]?.label;
      }

      let CS_WCParentId = 0;
      let CS_pdWCParentId = 0;
      let subCategoryDrp = subCategoryDrpList.filter(
        (d) => d.value === productData.SubCategoryID
      );
      if (subCategoryDrp && subCategoryDrp[0]) {
        CS_WCParentId = subCategoryDrp[0]?.wcid;
        CS_pdWCParentId = subCategoryDrp[0]?.pdWcid;
      }


      if (
        ((productData.IsGemar === true &&
          productData.IsPartyDeco === false &&
          C_WCParentId &&
          parseInt(C_WCParentId) > 0) ||
          (productData.IsPartyDeco === true &&
            productData.IsGemar === false &&
            C_pdWCParentId &&
            parseInt(C_pdWCParentId) > 0) ||
          (productData.IsPartyDeco === true &&
            productData.IsGemar === true &&
            C_WCParentId &&
            parseInt(C_WCParentId) > 0 &&
            C_pdWCParentId &&
            parseInt(C_pdWCParentId) > 0)) &&
        ((productData.IsGemar === true &&
          productData.IsPartyDeco === false &&
          CS_WCParentId &&
          parseInt(CS_WCParentId) > 0) ||
          (productData.IsPartyDeco === true &&
            productData.IsGemar === false &&
            CS_pdWCParentId &&
            parseInt(CS_pdWCParentId) > 0) ||
          (productData.IsPartyDeco === true &&
            productData.IsGemar === true &&
            CS_WCParentId &&
            parseInt(CS_WCParentId) > 0 &&
            CS_pdWCParentId &&
            parseInt(CS_pdWCParentId) > 0))
      ) {
        let oldProductAttributeModelList = [
          ...productData.ProductAttributeModelList,
        ];
        let isWCAttribute = !!oldProductAttributeModelList.find(
          (d) => d.WCAttributeID === null || d.WCAttributeID === 0
        );
        let isPDWCAttribute = !!oldProductAttributeModelList.find(
          (d) => d.PDWCAttributeID === null || d.PDWCAttributeID === 0
        );

        

        if (
          (productData.IsGemar === true &&
            productData.IsPartyDeco === false &&
            !isWCAttribute) ||
          (productData.IsPartyDeco === true &&
            productData.IsGemar === false &&
            !isPDWCAttribute) ||
          (productData.IsPartyDeco === true &&
            productData.IsGemar === true &&
            !isWCAttribute &&
            !isPDWCAttribute)
        ) {
          
          showLoader();
          let Param = {
            ProductID: 0,
            ProductName: productData.ProductName,
            SKU: productData.SKU,
            WarehouseID: productData.WarehouseOption.value,
            CategoryID: productData.CategoryOption.value,
            SubCategoryID: productData.SubCategoryOption.value,
            VendorID: productData.VendorOption.value,
          };

          let locationParams = {
            ProductID: 0,
            WareHouseNumber: productData.WarehouseOption.label,
            TypeProductLocationList:productData.TypeLocationList
          };

          CommonService.ProductLocationExistCheck(locationParams).then((locationRes) => {
            
            if (locationRes?.data?.length >0) {
             let locationVal='';
             locationRes.data.map((val, index) => {
              if(!locationVal)
                 {
                    locationVal=val.Aisle+val.Level+val.Bay;
                 }else{
                    locationVal=locationVal+","+(val.Aisle+val.Level+val.Bay);
                }
             });

              Toastr("This Location is already created ("+locationVal+")", "warning");
              hideLoader();
            }else{
          CommonService.ProductExistCheck(Param).then((res) => {
            if (res.data === 1) {
              // const categoryDrp = categoryDrpList.filter(d => d.value === productData.CategoryID);
              // const subCategoryDrp = subCategoryDrpList.filter(d => d.value === productData.SubCategoryID);
              const shippingMethodDrp = shippingMethodDrpList.filter(
                (d) => d.value === productData.ShippingMethodID
              );

              // let wooImages = [];
              // let PDWooImages = [];
              // productData &&
              //   productData.TypeProductImageModelList.filter(
              //     (d) => d.IsDeleted === false
              //   ).map((val) => {
              //     wooImages.push({ src: val.WCImageURL });
              //     PDWooImages.push({ src: val.PDWCImageURL });
              //   });

              let wooProductAttribute = [];
              let PDwooProductAttribute = [];
              let ProductTermList = [];

              productData &&
                oldProductAttributeModelList.map((val, index) => {
                  let AttributeIndexID = index + 1;
                  let attributeRow = { ...oldProductAttributeModelList[index] };
                  attributeRow.IndexID = AttributeIndexID;
                  oldProductAttributeModelList[index] = { ...attributeRow };

                  let attrOption = attributeDrpList.filter(
                    (d) => d.value === val.AttributeID
                  );
                  let wcIdAttributeID = attrOption && attrOption[0]?.wcid;
                  let PDwcIdAttributeID = attrOption && attrOption[0]?.pdWcid;

                  let WcOptions = [];

                  val.ProductTermOptionList &&
                    val.ProductTermOptionList.map((termVal) => {
                      WcOptions.push(termVal.label);
                      let term = {
                        ProductTermID: 0,
                        ProductID: productData.ProductID,
                        AttributeID: val.AttributeID,
                        ProductAttributeID: val.ProductAttributeID,
                        TermID: termVal.value,
                        Status: 1,
                        ProductAttributeIndex: AttributeIndexID,
                        IsDeleted: false,
                      };
                      ProductTermList.push(term);
                    });

                  let row = {
                    id: wcIdAttributeID,
                    position: 0,
                    visible: true,
                    variation: true,
                    options: WcOptions,
                  };
                  let PDRow = {
                    id: PDwcIdAttributeID,
                    position: 0,
                    visible: true,
                    variation: true,
                    options: WcOptions,
                  };
                  wooProductAttribute.push(row);

                  PDwooProductAttribute.push(PDRow);
                });

              productData.ProductAttributeModelList = [];
              productData.TypeProductAttributeModelList = [
                ...oldProductAttributeModelList,
              ];
              productData.ProductTermModelList = [];
              productData.TypeProductTermModelList = [...ProductTermList];
              productData.TypeProductLocationList = [...productData.TypeLocationList];
              productData.MinimumQuantity=productData.MinimumQuantity ?productData.MinimumQuantity:0;

              let stock_status = "instock";
              // if (productData.IsManageStock) {+
              if (productData.StockQuantity < 0) {
                stock_status = "outofstock";
              }
              // } else {
              //     if (productData && productData.StockstatusOption && productData.StockstatusOption.value) {
              //         if (productData.StockstatusOption.value === 3) {
              //             stock_status = "onbackorder";
              //         } else if (productData.StockstatusOption.value === 2) {
              //             stock_status = "outofstock";
              //         } else {
              //             stock_status = "instock";
              //         }
              //     }
              // }

              let backorder = "no";
              if (
                productData &&
                productData.AllowbackordersOption &&
                productData.AllowbackordersOption.value === 3
              ) {
                backorder = "yes";
              } else if (
                productData &&
                productData.AllowbackordersOption &&
                productData.AllowbackordersOption.value === 2
              ) {
                backorder = "notify";
              }

              let Cost;
              try {
                Cost = parseFloat(productData.Cost.replace(/\$|,/g, ""));
              } catch {
                Cost = productData.Cost;
              }

              let RegularPrice;
              try {
                RegularPrice = parseFloat(
                  productData.RegularPrice.replace(/\$|,/g, "")
                );
              } catch {
                RegularPrice = productData.RegularPrice;
              }

              let GPARTNERPrice;
              try {
                GPARTNERPrice = parseFloat(
                  productData.GPARTNERPrice.replace(/\$|,/g, "")
                );
              } catch {
                GPARTNERPrice = productData.GPARTNERPrice;
              }

              let GStarPrice;
              try {
                GStarPrice = parseFloat(
                  productData.GStarPrice.replace(/\$|,/g, "")
                );
              } catch {
                GStarPrice = productData.GStarPrice;
              }

              let PFAPrice;
              try {
                PFAPrice = parseFloat(
                  productData.PFAPrice.replace(/\$|,/g, "")
                );
              } catch {
                PFAPrice = productData.PFAPrice;
              }

              let GVendorPrice;
              try {
                GVendorPrice = parseFloat(
                  productData.GVendorPrice.replace(/\$|,/g, "")
                );
              } catch {
                GVendorPrice = productData.GVendorPrice;
              }

              let GAssociatePrice;
              try {
                GAssociatePrice = parseFloat(
                  productData.GAssociatePrice.replace(/\$|,/g, "")
                );
              } catch {
                GAssociatePrice = productData.GAssociatePrice;
              }
              let PartyDecoPrice;
              try {
                PartyDecoPrice = parseFloat(
                  productData.PartyDecoPrice.replace(/\$|,/g, "")
                );
              } catch {
                PartyDecoPrice = productData.PartyDecoPrice;
              }

              var end2 = performance.now();
              console.log(
                "Before Woocommerce API : " + Math.floor(end2 - start2) / 1000
              );

              // woocommerce params

              let UserRoleIgnoreDiscount = "0";
              const GemarData = {
                name: productData.ProductName,
                type: "simple",
                description: productData.Description,
                short_description: productData.ShortDescription,
                categories: [
                  {
                    id: categoryDrp && categoryDrp[0]?.wcid,
                  },
                  {
                    id: subCategoryDrp && subCategoryDrp[0]?.wcid,
                  },
                ],
                // images: wooImages,
                // price: productData.Cost.toString(),
                regular_price: RegularPrice.toString(),
                weight: productData.Weight && productData.Weight.toString(),
                dimensions: {
                  length:
                    productData.DimensionLength &&
                    productData.DimensionLength.toString(),
                  width:
                    productData.DimensionWidth &&
                    productData.DimensionWidth.toString(),
                  height:
                    productData.DimensionHeight &&
                    productData.DimensionHeight.toString(),
                },
                shipping_required: true,
                shipping_class:
                  shippingMethodDrp && shippingMethodDrp[0]?.label === "Next Day"
                    ? "next-day"
                    : shippingMethodDrp[0]?.label.toLowerCase(),
                shipping_class_id:
                  shippingMethodDrp && shippingMethodDrp[0]?.wcid,

                manage_stock: 1,
                stock_quantity: !productData.StockQuantity
                  ? "0"
                  : productData.StockQuantity &&
                    productData.StockQuantity.toString(),
                backorders: backorder,
                low_stock_amount: !productData.LowStockThreshold
                  ? "0"
                  : productData.LowStockThreshold &&
                    productData.LowStockThreshold.toString(),
                sku: productData.SKU,
                stock_status: stock_status,
                min_quantity:productData.MinimumQuantity ? productData.MinimumQuantity:0,
                attributes: wooProductAttribute,
                meta_data: [
                  {
                    key: "festiUserRoleIgnoreDiscount",
                    value: UserRoleIgnoreDiscount,
                  },
                  {
                    key: "festiUserRolePrices",
                    value: {
                      "g-partner": GPARTNERPrice.toString(),
                      "g-star": GStarPrice.toString(),
                      pfa: PFAPrice.toString(),
                      "g-vendor": GVendorPrice.toString(),
                      "g-associate": GAssociatePrice.toString(),
                    },
                  },
                  {
                    key: "_wc_cog_cost",
                    value: Cost.toString(),
                  },
                ],
              };
              const PartyDecoData = {
                name: productData.ProductName,
                type: "simple",
                description: productData.Description,
                short_description: productData.ShortDescription,
                categories: [
                  {
                    id: categoryDrp && categoryDrp[0]?.pdWcid,
                  },
                  {
                    id: subCategoryDrp && subCategoryDrp[0]?.pdWcid,
                  },
                ],
                // images: PDWooImages,
                // price: productData.Cost.toString(),
                regular_price: PartyDecoPrice.toString(),
                weight: productData.Weight && productData.Weight.toString(),
                dimensions: {
                  length:
                    productData.DimensionLength &&
                    productData.DimensionLength.toString(),
                  width:
                    productData.DimensionWidth &&
                    productData.DimensionWidth.toString(),
                  height:
                    productData.DimensionHeight &&
                    productData.DimensionHeight.toString(),
                },
                shipping_required: true,
                shipping_class:
                  shippingMethodDrp && shippingMethodDrp[0]?.label === "Next Day"
                    ? "next-day"
                    : shippingMethodDrp[0]?.label.toLowerCase(),
                shipping_class_id:
                  shippingMethodDrp && shippingMethodDrp[0]?.pdWcid,

                manage_stock: 1,
                stock_quantity: !productData.StockQuantity
                  ? "0"
                  : productData.StockQuantity &&
                    productData.StockQuantity.toString(),
                backorders: backorder,
                low_stock_amount: !productData.LowStockThreshold
                  ? "0"
                  : productData.LowStockThreshold &&
                    productData.LowStockThreshold.toString(),
                sku: productData.SKU,
                stock_status: stock_status,
                min_quantity:productData.MinimumQuantity ? productData.MinimumQuantity:0,
                attributes: PDwooProductAttribute,
                meta_data: [
                  {
                    key: "festiUserRoleIgnoreDiscount",
                    value: UserRoleIgnoreDiscount,
                  },
                  {
                    key: "festiUserRolePrices",
                    value: {
                      "g-partner": GPARTNERPrice.toString(),
                      "g-star": GStarPrice.toString(),
                      pfa: PFAPrice.toString(),
                      "g-vendor": GVendorPrice.toString(),
                      "g-associate": GAssociatePrice.toString(),
                    },
                  },
                  {
                    key: "_wc_cog_cost",
                    value: Cost.toString(),
                  },
                ],
              };

              productData.Cost = Cost;
              productData.RegularPrice = RegularPrice;
              productData.GPARTNERPrice = GPARTNERPrice;
              productData.GStarPrice = GStarPrice;
              productData.PFAPrice = PFAPrice;
              productData.GVendorPrice = GVendorPrice;
              productData.GAssociatePrice = GAssociatePrice;
              productData.PartyDecoPrice = PartyDecoPrice;
              if (!productData.StockQuantity) {
                productData.StockQuantity = 0;
              }
              if (!productData.LowStockThreshold) {
                productData.LowStockThreshold = 0;
              }
              if (!productData.HighStockThreshold) {
                productData.HighStockThreshold = 0;
              }

              if (
                productData.IsGemar === true &&
                productData.IsPartyDeco === true
              ) {
                AddProductGemarAndPA(productData, GemarData, PartyDecoData);
              } else if (productData.IsGemar === true) {
                AddProductGemar(productData, GemarData);
              } else if (productData.IsPartyDeco === true) {
                AddProductPA(productData, PartyDecoData);
              }
            } else if (res.data === 2) {
              Toastr("This Product Name is already created", "warning");
              hideLoader();
            } else if (res.data === 3) {
              Toastr("This SKU is already created", "warning");
              hideLoader();
            } else if (res.data === 4) {
              Toastr("This warehouse is  Inactive or Deleted", "warning");
              hideLoader();
            } else if (res.data === 5) {
              Toastr("This Category is  Inactive or Deleted", "warning");
              hideLoader();
            } else if (res.data === 6) {
              Toastr("This SubCategory is  Inactive or Deleted", "warning");
              hideLoader();
            } else if (res.data === 7) {
              Toastr("This Vendor is  Inactive or Deleted", "warning");
              hideLoader();
            } else {
              Toastr("error", "warning");
              hideLoader();
            }
          
          });
        }
        });

        } else {
          Toastr(
            "Please check attribute. Gemar and Partydeco must be same product ",
            "warning"
          );
        }
      } else {
        Toastr(
          "Please check Category and SubCategory. Gemar and PartyDeco must be same product",
          "warning"
        );
      }
    } else {
      productData.setSubmitted = true;

      dispatch(productActions.tempSetProductTabData(productData));

      if (error) {
        let validation = "Please fill in the required missing fields";

        // if (productData.Bay.length === 1 || productData.Aisle.length === 1) {
        //   validation = validation + " or  validate data";
        // }
        Toastr(validation, "warning");
      }

      if (isLocationDuplicate) {
        Toastr("please check previous data location is already used", "warning");
      }

      if (isErrorThreshold) {
        if (
          parseInt(productData.QuotaTrigger1) <
            parseInt(productData.QuotaTrigger2) ||
          parseInt(productData.QuotaTrigger1) ===
            parseInt(productData.QuotaTrigger2)
        ) {
          Toastr(
            "The Quota Trigger 1 should be greater than the Quota Trigger 2 value ",
            "warning"
          );
        }
      }
    }
  };

  
  function AddProductGemarAndPA(productData, GemarData, PartyDecoData) {
    var start = performance.now();

    restApi
      .post("products", GemarData)
      .then((response) => {
        console.log(response.data);
        if (
          response.status === 200 ||
          response.status === 201 ||
          !response.statusText
        ) {
          productData.WCProductID = response.data.id;
          response.data &&
            response.data.meta_data.map((val) => {
              if (val.key === "festiUserRoleIgnoreDiscount") {
                productData.WCUserRoleIgnoreDiscountID = val.id;
              } else if (val.key === "festiUserRolePrices") {
                productData.WCUserRolePricesID = val.id;
              } else if (val.key === "_wc_cog_cost") {
                productData.WCCOGCostID = val.id;
              }
            });

          restApi_PD
            .post("products", PartyDecoData)
            .then((PDResponse) => {
              console.log(PDResponse.data);
              if (
                PDResponse.status === 200 ||
                PDResponse.status === 201 ||
                !PDResponse.statusText
              ) {
                var end = performance.now();
                console.log(
                  "woocommerce API : " + Math.floor(end - start) / 1000
                );
                productData.PDWCProductID = PDResponse.data.id;

                PDResponse.data &&
                  PDResponse.data.meta_data.map((val) => {
                    if (val.key === "festiUserRoleIgnoreDiscount") {
                      productData.PDWCUserRoleIgnoreDiscountID = val.id;
                    } else if (val.key === "festiUserRolePrices") {
                      productData.PDWCUserRolePricesID = val.id;
                    } else if (val.key === "_wc_cog_cost") {
                      productData.PDWCCOGCostID = val.id;
                    }
                  });

                dispatch(productActions.saveProduct(productData));
              } else {
                hideLoader();
                Toastr("Party Deco : " + PDResponse.statusText, "warning");
              }
            })
            .catch((error) => {
              hideLoader();
              let msg = "";
              if (error.response) {
                if (error.response.data.code === "products_exists") {
                  msg = "";
                } else {
                  msg = error.response.data.message;
                }
              } else {
                msg = "rest Api error";
              }

              Toastr("PartyDeco : " + msg, "warning");
              console.log();
            });
        } else {
          hideLoader();
          Toastr("Gemar : " + response.statusText, "warning");
        }
      })
      .catch((error) => {
        hideLoader();
        let msg = "";
        if (error.response) {
          if (error.response.data.code === "products_exists") {
            msg = "";
          } else {
            msg = error.response.data.message;
          }
        } else {
          msg = "rest Api error";
        }

        Toastr("Gemar : " + msg, "warning");
        console.log();
      });
  }
  function AddProductGemar(productData, GemarData) {
    console.log("GemarData", GemarData);
    var start = performance.now();

    restApi
      .post("products", GemarData)
      .then((response) => {
        console.log(response.data);
        if (
          response.status === 200 ||
          response.status === 201 ||
          !response.statusText
        ) {
          var end = performance.now();
          console.log("woocommerce API : " + Math.floor(end - start) / 1000);
          productData.WCProductID = response.data.id;

          response.data &&
            response.data.meta_data.map((val) => {
              if (val.key === "festiUserRoleIgnoreDiscount") {
                productData.WCUserRoleIgnoreDiscountID = val.id;
              } else if (val.key === "festiUserRolePrices") {
                productData.WCUserRolePricesID = val.id;
              } else if (val.key === "_wc_cog_cost") {
                productData.WCCOGCostID = val.id;
              }
            });

          dispatch(productActions.saveProduct(productData));
        } else {
          hideLoader();
          Toastr("Gemar : " + response.statusText, "warning");
        }
      })
      .catch((error) => {
        hideLoader();
        let msg = "";
        if (error.response) {
          if (error.response.data.code === "products_exists") {
            msg = "";
          } else {
            msg = error.response.data.message;
          }
        } else {
          msg = "rest Api error";
        }

        Toastr("Gemar : " + msg, "warning");
        console.log();
      });
  }
  function AddProductPA(productData, PartyDecoData) {
    var start = performance.now();

    restApi_PD
      .post("products", PartyDecoData)
      .then((response) => {
        console.log(response.data);
        if (
          response.status === 200 ||
          response.status === 201 ||
          !response.statusText
        ) {
          var end = performance.now();
          console.log("woocommerce API : " + Math.floor(end - start) / 1000);
          productData.PDWCProductID = response.data.id;

          response.data &&
            response.data.meta_data.map((val) => {
              if (val.key === "festiUserRoleIgnoreDiscount") {
                productData.PDWCUserRoleIgnoreDiscountID = val.id;
              } else if (val.key === "festiUserRolePrices") {
                productData.PDWCUserRolePricesID = val.id;
              } else if (val.key === "_wc_cog_cost") {
                productData.PDWCCOGCostID = val.id;
              }
            });

          dispatch(productActions.saveProduct(productData));
        } else {
          hideLoader();
          Toastr("Party Deco : " + response.statusText, "warning");
        }
      })
      .catch((error) => {
        hideLoader();
        let msg = "";
        if (error.response) {
          if (error.response.data.code === "products_exists") {
            msg = "";
          } else {
            msg = error.response.data.message;
          }
        } else {
          msg = "rest Api error";
        }

        Toastr("PartyDeco : " + msg, "warning");
        console.log();
      });
  }

  // All Tab Add Product handleUpdateProduct function
  const handleUpdateProduct = async() => {
    const productData = { ...attributeTabData };
    productData.CreatedBy = currentUser.Id;
    let error = false;
    let isErrorThreshold = false;
    const IsLocationExist = productData.TypeLocationList.some((item, index) => item.Aisle === "" || item.Aisle === "0" || (item?.Aisle?.length !== 2) || item.Bay === "" || item.Bay === "0" || (item?.Bay?.length !== 2) || item.Level=== "");



    if (
      !productData.ProductName ||
      !productData.WarehouseOption ||
      !productData.CategoryOption ||
      !productData.SubCategoryOption ||
      // !productData.Aisle ||
      // productData.Aisle.length !== 2 ||
      // !productData.Level ||
      // productData.Level.length === 1 ||
      // !productData.Bay ||
      // productData.Bay.length !== 2 ||
      !productData.Description ||
      !productData.PackageTypeOption ||
      !productData.Cost ||
      productData.Cost === "$0.00" ||
      productData.PerBoxCount <= 0 ||
      !productData.RegularPrice ||
      productData.RegularPrice === "$0.00" ||
      !productData.GPARTNERPrice ||
      productData.GPARTNERPrice === "$0.00" ||
      !productData.GStarPrice ||
      productData.GStarPrice === "$0.00" ||
      !productData.PFAPrice ||
      productData.PFAPrice === "$0.00" ||
      !productData.GVendorPrice ||
      productData.GVendorPrice === "$0.00" ||
      !productData.GAssociatePrice ||
      productData.GAssociatePrice === "$0.00" ||
      !productData.Weight ||
      !parseFloat(productData.Weight && productData.Weight) > 0 ||
      !productData.DimensionLength ||
      !parseFloat(productData.DimensionLength && productData.DimensionLength) >
        0 ||
      !productData.DimensionWidth ||
      !parseFloat(productData.DimensionWidth && productData.DimensionWidth) >
        0 ||
      !productData.DimensionHeight ||
      !parseFloat(productData.DimensionHeight && productData.DimensionHeight) >
        0 ||
      !productData.ShippingMethodOption ||
      !productData.PartyDecoPrice ||
      productData.PartyDecoPrice === "$0.00" ||
      !productData.WarrantyPeriod  ||
      productData.WarrantyPeriod === 0 ||
      // InventoryTab
      !productData.SKU ||
      !productData.VendorOption ||
      !productData.Manufacturer ||
      (productData.IsGemar === false && productData.IsPartyDeco === false) ||
      IsLocationExist===true || productData?.TypeLocationList?.length===0
    ) {
      error = true;
    }

    if (
      !productData.AllowbackordersOption ||
      !productData.LowStockThreshold ||
      parseInt(productData.LowStockThreshold) === 0 ||
      !productData.HighStockThreshold ||
      parseInt(productData.HighStockThreshold) === 0
    ) {
      error = true;
    }

    if (!productData.QuotaTrigger1 || !productData.QuotaTrigger2) {
      error = true;
    }

    let isLocationDuplicate =false;
      if(productData?.TypeLocationList?.length > 1)
      {
        for (let item of productData.TypeLocationList) {
        
         let location= item.Aisle +item.Bay+ item.Level;
         let filterLocation= productData.TypeLocationList.filter(item=>(item.Aisle +item.Bay+ item.Level) === location && item.IsDeleted===false);

        if(filterLocation?.length>1)
        {
          isLocationDuplicate=true;
         // Toastr("please check previous data location is already used", "warning");
          break;
        }
       }
      }

    if (
      parseInt(productData.QuotaTrigger1) <
        parseInt(productData.QuotaTrigger2) ||
      parseInt(productData.QuotaTrigger1) ===
        parseInt(productData.QuotaTrigger2)
    ) {
      isErrorThreshold = true;
    }

    if (!error && !isErrorThreshold && !isLocationDuplicate) {
      let C_WCParentId = 0;
      let C_pdWCParentId = 0;
      let categoryDrp = categoryDrpList.filter(
        (d) => d.value === productData.CategoryID
      );
      if (categoryDrp && categoryDrp[0]) {
        C_WCParentId = categoryDrp[0]?.wcid;
        C_pdWCParentId = categoryDrp[0]?.pdWcid;
      }
      let CS_WCParentId = 0;
      let CS_pdWCParentId = 0;
      let subCategoryDrp = subCategoryDrpList.filter(
        (d) => d.value === productData.SubCategoryID
      );
      if (subCategoryDrp && subCategoryDrp[0]) {
        CS_WCParentId = subCategoryDrp[0]?.wcid;
        CS_pdWCParentId = subCategoryDrp[0]?.pdWcid;
      }
      if (
        ((productData.IsGemar === true &&
          productData.IsPartyDeco === false &&
          C_WCParentId &&
          parseInt(C_WCParentId) > 0) ||
          (productData.IsPartyDeco === true &&
            productData.IsGemar === false &&
            C_pdWCParentId &&
            parseInt(C_pdWCParentId) > 0) ||
          (productData.IsPartyDeco === true &&
            productData.IsGemar === true &&
            C_WCParentId &&
            parseInt(C_WCParentId) > 0 &&
            C_pdWCParentId &&
            parseInt(C_pdWCParentId) > 0)) &&
        ((productData.IsGemar === true &&
          productData.IsPartyDeco === false &&
          CS_WCParentId &&
          parseInt(CS_WCParentId) > 0) ||
          (productData.IsPartyDeco === true &&
            productData.IsGemar === false &&
            CS_pdWCParentId &&
            parseInt(CS_pdWCParentId) > 0) ||
          (productData.IsPartyDeco === true &&
            productData.IsGemar === true &&
            CS_WCParentId &&
            parseInt(CS_WCParentId) > 0 &&
            CS_pdWCParentId &&
            parseInt(CS_pdWCParentId) > 0))
      ) {
        let oldProductAttributeModelList = [
          ...productData.ProductAttributeModelList,
        ];
        let isWCAttribute = !!oldProductAttributeModelList.find(
          (d) => !d.WCAttributeID || d.WCAttributeID === 0
        );
        let isPDWCAttribute = !!oldProductAttributeModelList.find(
          (d) => !d.PDWCAttributeID || d.PDWCAttributeID === 0
        );
        
        if (
          (productData.IsGemar === true &&
            productData.IsPartyDeco === false &&
            !isWCAttribute) ||
          (productData.IsPartyDeco === true &&
            productData.IsGemar === false &&
            !isPDWCAttribute) ||
          (productData.IsPartyDeco === true &&
            productData.IsGemar === true &&
            !isWCAttribute &&
            !isPDWCAttribute)
        ) {
          
          showLoader();
          let Param = {
            ProductID: productData.ProductID,
            ProductName: productData.ProductName,
            SKU: productData.SKU,
            WarehouseID: productData.WarehouseOption.value,
            CategoryID: productData.CategoryOption.value,
            SubCategoryID: productData.SubCategoryOption.value,
            VendorID: productData.VendorOption.value,
          };

          let TypeLocationList = [...productData.TypeLocationList];

TypeLocationList.map((val, index) => {
  let locationVal = val.Aisle + val.Level + val.Bay;

  let locationRowIndex = TypeLocationList.findIndex(
    (d) => d.Aisle + d.Level + d.Bay === locationVal && d.ProductLocationID > 0 && d.IsDeleted === true
  );

  if (locationRowIndex !== -1 && TypeLocationList[locationRowIndex].ProductLocationID > 0 && val.IsDeleted === false) {
    let row = { ...TypeLocationList[index] };
    row.ProductLocationID = TypeLocationList[locationRowIndex].ProductLocationID;
    TypeLocationList[index] = { ...row };

    // Remove locationRow from TypeLocationList after processing
    TypeLocationList.splice(locationRowIndex, 1);
  }
});



          let locationParams = {
            ProductID:  productData.ProductID,
            WareHouseNumber: productData.WarehouseOption.label,
            TypeProductLocationList:TypeLocationList
          };
          CommonService.ProductLocationExistCheck(locationParams).then((locationRes) => {
            
            if (locationRes?.data?.length >0) {
             let locationVal='';
             locationRes.data.map((val, index) => {
              if(!locationVal)
                 {
                    locationVal=val.Aisle+val.Level+val.Bay;
                 }else{
                    locationVal=locationVal+","+(val.Aisle+val.Level+val.Bay);
                }
             });

              Toastr("This Location is already created ("+locationVal+")", "warning");
              hideLoader();
            }else{
           CommonService.ProductExistCheck(Param).then(async(res) => {
            if (res.data === 1) {
            
              const shippingMethodDrp = shippingMethodDrpList.filter(
                (d) => d.value === productData.ShippingMethodID
              );

              let wooProductAttribute = [];
              let PDwooProductAttribute = [];
              let ProductTermList = [];
              let oldProductAttributeModelList = [
                ...productData.ProductAttributeModelList,
              ];
              productData &&
                oldProductAttributeModelList.map((val, index) => {
                  let AttributeIndexID = index + 1;
                  let attributeRow = { ...oldProductAttributeModelList[index] };
                  attributeRow.IndexID = AttributeIndexID;
                  oldProductAttributeModelList[index] = { ...attributeRow };

                  let attrOption = attributeDrpList.filter(
                    (d) => d.value === val.AttributeID
                  );
                  let wcIdAttributeID = attrOption && attrOption[0]?.wcid;
                  let PDwcIdAttributeID = attrOption && attrOption[0]?.pdWcid;

                  let WcOptions = [];

                  val.ProductTermOptionList &&
                    val.ProductTermOptionList.map((termVal) => {
                      if (val.IsDeleted === false) {
                        WcOptions.push(termVal.label);
                      }
                      let ProductTermIDVal = 0;
                      let TermDeleted = false;
                      if (val.ProductAttributeID > 0) {
                        const chkProductTerm =
                          productData.ProductTermModelList &&
                          productData.ProductTermModelList.filter(
                            (d) =>
                              d.TermID === termVal.value &&
                              d.AttributeID === val.AttributeID
                          );

                        if (chkProductTerm && chkProductTerm[0]) {
                          ProductTermIDVal = chkProductTerm[0]?.ProductTermID;
                          TermDeleted = chkProductTerm[0]?.IsDeleted;
                        }
                        if (val.IsDeleted === true) {
                          TermDeleted = true;
                        }
                      }

                      let term = {
                        ProductTermID: ProductTermIDVal,
                        ProductID: productData.ProductID,
                        AttributeID: val.AttributeID,
                        ProductAttributeID: val.ProductAttributeID,
                        TermID: termVal.value,
                        Status: 1,
                        ProductAttributeIndex: AttributeIndexID,
                        IsDeleted: TermDeleted,
                      };
                      ProductTermList.push(term);
                    });

                  if (val.IsDeleted === false) {
                    let row = {
                      id: wcIdAttributeID,
                      position: 0,
                      visible: true,
                      variation: true,
                      options: WcOptions,
                    };
                    let PDRow = {
                      id: PDwcIdAttributeID,
                      position: 0,
                      visible: true,
                      variation: true,
                      options: WcOptions,
                    };
                    wooProductAttribute.push(row);
                    PDwooProductAttribute.push(PDRow);
                  }
                });

              productData.ProductAttributeModelList = [];
              productData.TypeProductAttributeModelList = [
                ...oldProductAttributeModelList,
              ];
              productData.ProductTermModelList = [];
              productData.TypeProductTermModelList = [...ProductTermList];

              productData.TypeProductLocationList=[...TypeLocationList];
              productData.MinimumQuantity=productData.MinimumQuantity ?productData.MinimumQuantity:0;

              let stock_status = "instock";
              if (productData.StockQuantity < 0) {
                stock_status = "outofstock";
              }

              let backorder = "no";
              if (
                productData &&
                productData.AllowbackordersOption &&
                productData.AllowbackordersOption.value === 3
              ) {
                backorder = "yes";
              } else if (
                productData &&
                productData.AllowbackordersOption &&
                productData.AllowbackordersOption.value === 2
              ) {
                backorder = "notify";
              }
              let Cost;
              try {
                Cost = parseFloat(productData.Cost.replace(/\$|,/g, ""));
              } catch {
                Cost = productData.Cost;
              }

              let RegularPrice;
              try {
                RegularPrice = parseFloat(
                  productData.RegularPrice.replace(/\$|,/g, "")
                );
              } catch {
                RegularPrice = productData.RegularPrice;
              }

              let GPARTNERPrice;
              try {
                GPARTNERPrice = parseFloat(
                  productData.GPARTNERPrice.replace(/\$|,/g, "")
                );
              } catch {
                GPARTNERPrice = productData.GPARTNERPrice;
              }

              let GStarPrice;
              try {
                GStarPrice = parseFloat(
                  productData.GStarPrice.replace(/\$|,/g, "")
                );
              } catch {
                GStarPrice = productData.GStarPrice;
              }

              let PFAPrice;
              try {
                PFAPrice = parseFloat(
                  productData.PFAPrice.replace(/\$|,/g, "")
                );
              } catch {
                PFAPrice = productData.PFAPrice;
              }

              let GVendorPrice;
              try {
                GVendorPrice = parseFloat(
                  productData.GVendorPrice.replace(/\$|,/g, "")
                );
              } catch {
                GVendorPrice = productData.GVendorPrice;
              }

              let GAssociatePrice;
              try {
                GAssociatePrice = parseFloat(
                  productData.GAssociatePrice.replace(/\$|,/g, "")
                );
              } catch {
                GAssociatePrice = productData.GAssociatePrice;
              }
              let PartyDecoPrice;
              try {
                PartyDecoPrice = parseFloat(
                  productData.PartyDecoPrice.replace(/\$|,/g, "")
                );
              } catch {
                PartyDecoPrice = productData.PartyDecoPrice;
              }

              // woocommerce params

              let UserRoleIgnoreDiscount = "0";
              const GemarData = {
                name: productData.ProductName,
                type: "simple",
                status:"publish",
                description: productData.Description,
                short_description: productData.ShortDescription,
                categories: [
                  {
                    id: categoryDrp && categoryDrp[0]?.wcid,
                  },
                  {
                    id: subCategoryDrp && subCategoryDrp[0]?.wcid,
                  },
                ],
                //images: wooImages,
                // price: productData.Cost.toString(),
                regular_price: RegularPrice.toString(),
                weight: productData.Weight && productData.Weight.toString(),
                dimensions: {
                  length:
                    productData.DimensionLength &&
                    productData.DimensionLength.toString(),
                  width:
                    productData.DimensionWidth &&
                    productData.DimensionWidth.toString(),
                  height:
                    productData.DimensionHeight &&
                    productData.DimensionHeight.toString(),
                },
                shipping_required: true,
                shipping_class:
                  shippingMethodDrp && shippingMethodDrp[0]?.label === "Next Day"
                    ? "next-day"
                    : shippingMethodDrp[0]?.label.toLowerCase(),
                shipping_class_id:
                  shippingMethodDrp && shippingMethodDrp[0]?.wcid,

                manage_stock: 1,
                stock_quantity: !productData.StockQuantity
                  ? "0"
                  : productData.StockQuantity && productData.StockQuantity,
                backorders: backorder,
                low_stock_amount: !productData.LowStockThreshold
                  ? "0"
                  : productData.LowStockThreshold &&
                    productData.LowStockThreshold.toString(),
                sku: productData.SKU,
                stock_status: stock_status,
                min_quantity:productData.MinimumQuantity ? productData.MinimumQuantity:0,
                attributes: wooProductAttribute,
                meta_data: [
                  {
                    id: productData.WCUserRoleIgnoreDiscountID,
                    key: "festiUserRoleIgnoreDiscount",
                    value: UserRoleIgnoreDiscount,
                  },
                  {
                    id: productData.WCUserRolePricesID,
                    key: "festiUserRolePrices",
                    value: {
                      "g-partner": GPARTNERPrice.toString(),
                      "g-star": GStarPrice.toString(),
                      pfa: PFAPrice.toString(),
                      "g-vendor": GVendorPrice.toString(),
                      "g-associate": GAssociatePrice.toString(),
                    },
                  },
                  {
                    id: productData.WCCOGCostID,
                    key: "_wc_cog_cost",
                    value: Cost.toString(),
                  },
                ],
              };

              const PartyDecoData = {
                name: productData.ProductName,
                type: "simple",
                status:"publish",
                description: productData.Description,
                short_description: productData.ShortDescription,
                categories: [
                  {
                    id: categoryDrp && categoryDrp[0]?.pdWcid,
                  },
                  {
                    id: subCategoryDrp && subCategoryDrp[0]?.pdWcid,
                  },
                ],
                // images: PDWooImages,
                // price: productData.Cost.toString(),
                regular_price: PartyDecoPrice.toString(),
                weight: productData.Weight && productData.Weight.toString(),
                dimensions: {
                  length:
                    productData.DimensionLength &&
                    productData.DimensionLength.toString(),
                  width:
                    productData.DimensionWidth &&
                    productData.DimensionWidth.toString(),
                  height:
                    productData.DimensionHeight &&
                    productData.DimensionHeight.toString(),
                },
                shipping_required: true,
                shipping_class:
                  shippingMethodDrp && shippingMethodDrp[0]?.label === "Next Day"
                    ? "next-day"
                    : shippingMethodDrp[0]?.label.toLowerCase(),
                shipping_class_id:
                  shippingMethodDrp && shippingMethodDrp[0]?.pdWcid,

                manage_stock: 1,
                stock_quantity: !productData.StockQuantity
                  ? "0"
                  : productData.StockQuantity && productData.StockQuantity,
                backorders: backorder,
                low_stock_amount: !productData.LowStockThreshold
                  ? "0"
                  : productData.LowStockThreshold &&
                    productData.LowStockThreshold.toString(),
                sku: productData.SKU,
                stock_status: stock_status,
                min_quantity:productData.MinimumQuantity ? productData.MinimumQuantity:0,
                attributes: PDwooProductAttribute,
                meta_data: [
                  {
                    id: productData.PDWCUserRoleIgnoreDiscountID,
                    key: "festiUserRoleIgnoreDiscount",
                    value: UserRoleIgnoreDiscount,
                  },
                  {
                    id: productData.PDWCUserRolePricesID,
                    key: "festiUserRolePrices",
                    value: {
                      "g-partner": GPARTNERPrice.toString(),
                      "g-star": GStarPrice.toString(),
                      pfa: PFAPrice.toString(),
                      "g-vendor": GVendorPrice.toString(),
                      "g-associate": GAssociatePrice.toString(),
                    },
                  },
                  {
                    id: productData.PDWCCOGCostID,
                    key: "_wc_cog_cost",
                    value: Cost.toString(),
                  },
                ],
              };

              productData.Cost = Cost;
              productData.RegularPrice = RegularPrice;
              productData.GPARTNERPrice = GPARTNERPrice;
              productData.GStarPrice = GStarPrice;
              productData.PFAPrice = PFAPrice;
              productData.GVendorPrice = GVendorPrice;
              productData.GAssociatePrice = GAssociatePrice;
              productData.PartyDecoPrice = PartyDecoPrice;

              if (!productData.StockQuantity) {
                productData.StockQuantity = 0;
              }
              if (!productData.LowStockThreshold) {
                productData.LowStockThreshold = 0;
              }
              if (!productData.HighStockThreshold) {
                productData.HighStockThreshold = 0;
              }

              const previousProduct = { ...previousProductTabList };

                let isGemarResponse=false;
                let isPartyDecoResponse=false;

              try{
 //Gemar woocommerce working steps
 if(productData.IsGemar===true ) 
  {
   
    // Add New Gemar in  woocommerce
    if((!previousProduct?.WCProductID || previousProduct?.WCProductID===0))
      {
        let response = await restApi.post("products", GemarData);
        if (response?.status === 200 || response?.status === 201 || !response?.statusText) {
          productData.WCProductID = response.data.id;
          response && response.data &&
           response.data.meta_data.map((val) => {
             if (val.key === "festiUserRoleIgnoreDiscount") {
                productData.WCUserRoleIgnoreDiscountID = val.id;
             } else if (val.key === "festiUserRolePrices") {
                  productData.WCUserRolePricesID = val.id;
             } else if (val.key === "_wc_cog_cost") {
                    productData.WCCOGCostID = val.id;
             }
          });
          isGemarResponse=true;

            } else {
              hideLoader();
              if(response)
              {
                Toastr("Gemar : " + response?.statusText, "warning");
              }else
              {
                Toastr("Gemar : rest Api error", "warning");
              }
              return false;
            }
      }else
      {
       // Update Gemar in  woocommerce
        let response = await restApi.post("products/" + productData.WCProductID, GemarData);
        if (response?.status === 200 || response?.status === 201 || !response?.statusText) {
          isGemarResponse=true;
            } else {
              hideLoader();
              if(response)
              {
                Toastr("Gemar : " + response?.statusText, "warning");
              }else
              {
                Toastr("Gemar : rest Api error", "warning");
              }
              return false;
            }
      }
    }else
    {
      
      if(productData.IsGemar!==previousProduct.IsGemar )
      {
         // Delete Gemar in woocommerce

        const ApiData = {status: 'draft'};
        let response = await restApi.post("products/" + productData.WCProductID, ApiData);
        if (response?.status === 200 || response?.status === 201 || !response?.statusText) {
          isGemarResponse=true;
            } else {
              hideLoader();
              if(response)
              {
                Toastr("Gemar : " + response?.statusText, "warning");
              }else
              {
                Toastr("Gemar : rest Api error", "warning");
              }
              return false;
            }
      }else
      {
         // No changes Gemar in woocommerce
        isGemarResponse=true;
      }
    }

  //PartyDeco woocommerce working steps
  if(isGemarResponse===true)
  {
    if(productData.IsPartyDeco===true ) 
     {
   
      // Add New Party Deco in  woocommerce
       if((!previousProduct?.PDWCProductID || previousProduct?.PDWCProductID===0))
       {
        let response = await restApi_PD.post("products", PartyDecoData);
        if (response?.status === 200 || response?.status === 201 || !response?.statusText) {
          productData.PDWCProductID = response.data.id;
             response && response.data && response.data.meta_data.map((val) => {
                  if (val.key === "festiUserRoleIgnoreDiscount") {
                      productData.PDWCUserRoleIgnoreDiscountID = val.id;
                   } else if (val.key === "festiUserRolePrices") {
                       productData.PDWCUserRolePricesID = val.id;
                   } else if (val.key === "_wc_cog_cost") {
                      productData.PDWCCOGCostID = val.id;
                   }
                });
                       isPartyDecoResponse=true;

     } else {
             hideLoader();
             if(response)
              {
                Toastr("Party Deco : " + response?.statusText, "warning");
              }else
              {
                Toastr("Party Deco : rest Api error", "warning");
               }
              return false;
          }

        }else
        {
         
          let response = await restApi_PD.post("products/" + productData.PDWCProductID, PartyDecoData);
          if (response?.status === 200 || response?.status === 201 || !response?.statusText) {
            isPartyDecoResponse=true;
              } else {
                hideLoader();
                if(response)
                {
                  Toastr("Party Deco : " + response?.statusText, "warning");
                }else
                {
                  Toastr("Party Deco : rest Api error", "warning");
                }
                return false;
              }
        }
      }else
      {
        if(productData.IsPartyDeco!==previousProduct.IsPartyDeco )
          {
            const ApiData = {status: 'draft'};
            let response = await restApi_PD.post("products/" + productData.PDWCProductID, ApiData);
            if (response?.status === 200 || response?.status === 201 || !response?.statusText) {
              isPartyDecoResponse=true;
                } else {
                  hideLoader();
                  if(response)
                  {
                    Toastr("Party Deco : " + response?.statusText, "warning");
                  }else
                  {
                    Toastr("Party Deco : rest Api error", "warning");
                  }
                  return false;
                }
          }else
          {
            isPartyDecoResponse=true;
          }
    
           }

    }

    if(isGemarResponse===true && isPartyDecoResponse===true)
      {
        dispatch(productActions.saveProduct(productData));
      }else
      {
        Toastr("Gemar or Party Deco woocommerce not saved", "warning");
        hideLoader();
      }
// }
                }catch(error)
                {
                  
                  Toastr(
                    error?.response
                      ? error?.response?.data?.message +" ("+error?.config?.url+")"
                      : "rest Api error",
                    "warning"
                  );
                  hideLoader();
                }

               

            } else if (res.data === 2) {
              Toastr("This Product Name is already created", "warning");
              hideLoader();
            } else if (res.data === 3) {
              Toastr("This SKU is already created", "warning");
              hideLoader();
            } else if (res.data === 4) {
              Toastr("This warehouse is  Inactive or Deleted", "warning");
              hideLoader();
            } else if (res.data === 5) {
              Toastr("This Category is  Inactive or Deleted", "warning");
              hideLoader();
            } else if (res.data === 6) {
              Toastr("This SubCategory is  Inactive or Deleted", "warning");
              hideLoader();
            } else if (res.data === 7) {
              Toastr("This Vendor is  Inactive or Deleted", "warning");
              hideLoader();
            } else {
              Toastr("error", "warning");
              hideLoader();
            }
          });
        }
      });
          
        } else {
          Toastr(
            "Please check attribute. Gemar and Partydeco must be same product ",
            "warning"
          );
        }
      } else {
        Toastr(
          "Please check Category and SubCategory. Gemar and PartyDeco must be same product",
          "warning"
        );
      }
    } else {
      const productData = { ...attributeTabData };
      productData.setSubmitted = true;

      dispatch(productActions.tempSetProductTabData(productData));
      if (error) {
        let validation = "Please fill in the required missing fields";

        // if (productData.Bay.length === 1 || productData.Aisle.length === 1) {
        //   validation = validation + " or validate data";
        // }
        Toastr(validation, "warning");
      }
      // if (!error && isErrorThreshold) {
      //     if (((parseInt(productData.StockQuantity) < parseInt(productData.LowStockThreshold)) || (!productData.LowStockThreshold))) {
      //         Toastr('Low stock threshold should be less than stock Quantity ', 'warning');
      //     } else if (((parseInt(productData.LowStockThreshold) > parseInt(productData.HighStockThreshold)) || (parseInt(productData.StockQuantity) > parseInt(productData.HighStockThreshold)))) {
      //         Toastr('Low stock threshold should be less than high stock threshold and stock Quantity  should be less than high stock threshold', 'warning');
      //     }
      // }

      if (isLocationDuplicate) {
        Toastr("please check previous data location is already used", "warning");
      }
      if (isErrorThreshold) {
        if (
          parseInt(productData.QuotaTrigger1) <=
          parseInt(productData.QuotaTrigger2)
        ) {
          Toastr(
            "The Quota Trigger 1 should be greater than the Quota Trigger 2 value ",
            "warning"
          );
        }
      }
    }
  };


  // Product Add And Update
  useEffect(() => {
    if (productResponse === 1) {
      hideLoader();
      navigate("/ProductList");
    } else if (productResponse === 2) {
      hideLoader();
      navigate("/ProductList");
    } else if (productResponse === -1) {
      hideLoader();
      Toastr("Product Name or SKU Id already exists ", "warning");
    } else if (productResponse === -2) {
      hideLoader();
      Toastr("Location already exists ", "warning");
    } else if (productResponse < -1) {
      hideLoader();
      Toastr("Product error ", "warning");
    }
  }, [productResponse]);

  return (
    <Fragment>
      <div className="tab-content">
        <div className="pt-3">
          <div className="Inventory-form">
            <h4 className="text-primary">Attributes</h4>

            <div className="row pb-3">
              <div className="form-group col-xl-6 mb-3">
                <Select
                  classNamePrefix={"custom_select_css"}
                  name="AttributeID"
                  value={attributeTabData.AttributeOption}
                  options={attributeDrpList}
                  onChange={(event) => handleDrpChange(event, "AttributeID")}
                  isDisabled={currentUser?.UserTypeID === 8}
                  // styles={submitted && attributeTabData.AttributeID === 0 ? styles : ''}
                />
              </div>
              <div className="form-group col-xl-2">
                 {currentUser.UserTypeID !== 8 && (
                <button
                  className="btn btn-primary "
                  onClick={() => handleAddAttribute()}
                  
                  type="button"
                >
                  Add
                </button>
                 )}
              </div>
            </div>
            <Row>
              {attributeTabData &&
                attributeTabData.ProductAttributeModelList &&
                attributeTabData.ProductAttributeModelList.map(
                  (inputField, index) =>
                    inputField.IsDeleted === false && (
                      <Fragment key={`${inputField}~${index}`}>
                        <Col xl="6">
                          <Card className="custom-card-border">
                            <Card.Header>
                              <Card.Title>
                                {" "}
                                {inputField.AttributeName}
                              </Card.Title>
                             {currentUser?.UserTypeId !== 8 && (
  <span
    className="float-right"
    role="button"
    onClick={() =>
      handleRemoveAttribute(
        index,
        inputField.AttributeID,
        inputField.ProductAttributeID
      )
    }
  >
    <i className="fas fa-times"></i>
  </span>
)}

                            </Card.Header>
                            <Card.Body className="custom-card-body">
                              <Select
                                classNamePrefix={"custom_select_css"}
                                onChange={(event) =>
                                  handleTermDrpChange(
                                    event,
                                    index,
                                    inputField.AttributeID,
                                    inputField.ProductAttributeID
                                  )
                                }
                                value={inputField.ProductTermOptionList}
                                 isDisabled={currentUser?.UserTypeID === 8}
                                isMulti
                                options={
                                  termDrpList &&
                                  termDrpList.filter(
                                    (d) => d.parentId === inputField.AttributeID
                                  )
                                }
                              />
                            </Card.Body>
                          </Card>
                        </Col>
                      </Fragment>
                    )
                )}
            </Row>
          {currentUser.UserTypeID !== 8 && (
  <button
    className="btn btn-primary float-end"
    onClick={() =>
      attributeTabData.ProductID > 0
        ? handleUpdateProduct()
        : handleInsertProduct()
    }
    type="button"
  >
    Submit
  </button>
)}

            <button
              className="btn btn-danger float-end"
              style={{ marginRight: "17px" }}
              onClick={prevTab}
              type="button"
            >
              Previous
            </button>
          </div>
        </div>
      </div>
      {loader}
    </Fragment>
  );
};
export default React.memo(AttributesTab);
